
<div class="pdfcontainer" *ngIf = "!stream">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="pdfcontainer" *ngIf = "stream">
  <particle-platform-pdf-viewer [stream] = 'stream' [sidenavToggleDisabled] = "true" (downloadPdf) = "downloadPdf($event)">
  </particle-platform-pdf-viewer>
</div>

